import React from "react";
import { Helmet } from "react-helmet";
import { canonicalUrl } from "../../../Service/seoUrl";

function SeoMeta({
  title,
  description,
  canonical,
  image,
  type = "website",
  noindex = false,
  structuredData,
}) {
  // Always point at the URL the server actually answers with (trailing slash).
  canonical = canonical ? canonicalUrl(canonical) : canonical;

  return (
    <Helmet>
      {title ? <title>{title}</title> : null}
      {description ? <meta name="description" content={description} /> : null}
      {canonical ? <link rel="canonical" href={canonical} /> : null}
      {noindex ? <meta name="robots" content="noindex,nofollow" /> : null}
      {title ? <meta property="og:title" content={title} /> : null}
      {description ? <meta property="og:description" content={description} /> : null}
      {canonical ? <meta property="og:url" content={canonical} /> : null}
      {image ? <meta property="og:image" content={image} /> : null}
      <meta property="og:type" content={type} />
      <meta name="twitter:card" content="summary_large_image" />
      {title ? <meta name="twitter:title" content={title} /> : null}
      {description ? <meta name="twitter:description" content={description} /> : null}
      {image ? <meta name="twitter:image" content={image} /> : null}
      {structuredData ? (
        <script type="application/ld+json">{JSON.stringify(structuredData)}</script>
      ) : null}
    </Helmet>
  );
}

export default SeoMeta;
